<script>
    import { params, redirect } from "@roxi/routify";
    import { ServiceConsts } from "../../../services/ServiceConsts";

    function sendAuthRequestToBackgroundScript(extensionId) {
        return new Promise((resolve, reject) => {
            if (!chrome || !chrome.runtime) {
                console.log("No chrome runtime");
                return resolve(false);
            }

            chrome?.runtime.sendMessage(
                extensionId,
                {
                    from: "webapp",
                    subject: "authCodeReceived",
                    id: $params.id,
                    code: $params.code,
                },
                (response) => {
                    if (chrome?.runtime?.lastError) {
                        console.log(chrome.runtime.lastError);
                        return resolve(false);
                    }

                    return resolve(true);
                },
            );
        });
    }

    async function loginExtension() {
        const loginChrome = await sendAuthRequestToBackgroundScript(
            ServiceConsts.CHROME_EXTENSION_ID,
        );
        const loginEdge = await sendAuthRequestToBackgroundScript(
            ServiceConsts.EDGE_EXTENSION_ID,
        );

        return loginChrome || loginEdge;
    }
</script>

{#await loginExtension()}
    Authorizing extension...
{:then result}
    {$redirect(
        `/auth/login?redirectUrl=${window.location.origin + "/welcome"}`,
    )}
{:catch}
    Something went wrong
{/await}
